import { setDiagramVisualizer } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';
export type Props = ApiMethodBase & {}

export const processFindingUpdateDiagram = ({
    eventEmitter,
}: Props) => {
    eventEmitter.emit(Event.processFinding);
    setDiagramVisualizer()
    eventEmitter.emit(Event.updateGaugeMetrics);
};

